/* Carrousel "Les chiens de la communauté".

   1. Remplace les chiens statiques d'index.liquid par les photos validées
      (voir n8n-dog-photo-decision-workflow.json). En cas d'échec ou de liste
      vide, les chiens codés en dur restent affichés — aucune casse possible.

   2. Défilement automatique piloté ici, en JS, via scrollLeft — et non par une
      animation CSS transform. C'est le point clé : l'auto-défilement et le
      contrôle manuel (doigt, glissé souris, flèches, molette) manipulent alors
      la même valeur, au lieu de se battre l'un contre l'autre. */
(function () {
  var track = document.querySelector('[data-dogwall-track]');
  if (!track) return;

  var row = track.closest('.jl-dogwall__row');
  if (!row) return;

  var viewport = row.closest('.jl-dogwall__viewport');
  var prevBtn  = viewport ? viewport.querySelector('[data-dogwall-prev]') : null;
  var nextBtn  = viewport ? viewport.querySelector('[data-dogwall-next]') : null;

  var DOGS_ENDPOINT = 'https://n8n.jacquelineslab.com/webhook/dog-photos-approved';
  var SPEED         = 0.35; /* px par frame ≈ 21 px/s : lent, non agressif */
  var RESUME_DELAY  = 2000; /* reprise après une interaction, en ms */

  var looping  = false;
  var setWidth = 0;   /* largeur d'un jeu complet de chiens */
  var setHtml  = '';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function buildSet(dogs, addHref) {
    var html = dogs.map(function (dog) {
      return '<figure class="jl-dogwall__item">' +
        '<img class="jl-dogwall__bubble" src="' + escapeHtml(dog.photoUrl) + '" alt="' + escapeHtml(dog.prenom) + '" width="92" height="92" loading="lazy">' +
        '<figcaption>' + escapeHtml(dog.prenom) + '</figcaption>' +
        '</figure>';
    }).join('');
    html += '<a href="' + addHref + '" class="jl-dogwall__add" aria-label="Ajoute la photo de ton chien"><span>+</span><small>Ajoute<br>le tien</small></a>';
    return html;
  }

  /* Met mise en page à jour : soit tout tient à l'écran (statique et centré),
     soit on duplique assez de fois pour que la boucle soit atteignable — un
     seul doublon ne suffit pas si un jeu est plus étroit que l'écran. */
  function layout() {
    if (!setHtml) return;

    track.innerHTML = setHtml;                 /* 1 jeu, pour mesurer */
    track.classList.remove('is-looping');
    setWidth = track.scrollWidth;

    var vw = row.clientWidth || window.innerWidth;

    if (setWidth <= vw + 8) {
      looping = false;
      row.classList.add('jl-dogwall__row--static');
      refreshNav();
      return;
    }

    looping = true;
    row.classList.remove('jl-dogwall__row--static');

    var copies = Math.ceil(vw / setWidth) + 2; /* marge des deux côtés */
    var html = setHtml;
    for (var i = 1; i < copies; i++) {
      html += '<div class="jl-dogwall__dup" aria-hidden="true">' + setHtml + '</div>';
    }
    track.innerHTML = html;

    /* On démarre un jeu plus loin : il y a alors de la marge pour boucler
       dans les deux sens (avant comme arrière). */
    row.scrollLeft = setWidth;
    refreshNav();
  }

  fetch(DOGS_ENDPOINT)
    .then(function (res) { return res.ok ? res.json() : []; })
    .then(function (dogs) {
      if (!Array.isArray(dogs) || dogs.length === 0) return;
      setHtml = buildSet(dogs, track.getAttribute('data-dogwall-add-href') || '/pages/mon-chien');
      layout();
    })
    .catch(function () { /* silencieux : on garde les chiens statiques */ })
    .then(function () { refreshNav(); });

  /* ── Contrôles ────────────────────────────────────────────────── */

  var paused = false, resumeTimer = null;

  function pause() {
    paused = true;
    if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
  }
  function resumeSoon(delay) {
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () { paused = false; }, delay || RESUME_DELAY);
  }

  function canScroll() { return row.scrollWidth - row.clientWidth > 4; }

  function refreshNav() {
    var show = canScroll();
    if (prevBtn) prevBtn.hidden = !show;
    if (nextBtn) nextBtn.hidden = !show;
  }

  /* Boucle sans couture : les jeux étant identiques, le saut d'une largeur de
     jeu au moment du raccord est invisible. */
  function wrap() {
    if (!looping || setWidth <= 0) return;
    if (row.scrollLeft >= setWidth * 2) row.scrollLeft -= setWidth;
    else if (row.scrollLeft <= 0) row.scrollLeft += setWidth;
  }

  var animating = false;

  function tick() {
    if (!paused && !animating && looping && canScroll()) {
      row.scrollLeft += SPEED;
      wrap();
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  /* Animation maison plutôt que scrollBy({behavior:'smooth'}) : le défilement
     natif est annulé dès qu'on écrit scrollLeft (ce que fait la boucle
     ci-dessus). En appliquant des incréments, on reste aussi compatible avec
     le saut de bouclage, qui invaliderait une position absolue. */
  function animateScrollBy(total, duration) {
    var t0 = null, applied = 0;
    animating = true;
    function frame(now) {
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      var target = total * eased;
      row.scrollLeft += (target - applied);
      applied = target;
      wrap();
      if (p < 1) requestAnimationFrame(frame);
      else animating = false;
    }
    requestAnimationFrame(frame);
  }

  /* Survol : pause, mais le glissé et les flèches restent utilisables. */
  row.addEventListener('mouseenter', pause);
  row.addEventListener('mouseleave', function () { if (!isDown) resumeSoon(300); });

  row.addEventListener('scroll', function () { wrap(); }, { passive: true });
  row.addEventListener('wheel',  function () { pause(); resumeSoon(); }, { passive: true });

  /* Flèches : ~3 bulles par clic. */
  function step() {
    var item = row.querySelector('.jl-dogwall__item, .jl-dogwall__add');
    var gap  = parseFloat(window.getComputedStyle(track).gap) || 26;
    var w    = item ? item.getBoundingClientRect().width : 92;
    return Math.round((w + gap) * 3);
  }
  if (prevBtn) prevBtn.addEventListener('click', function () {
    pause(); animateScrollBy(-step(), 450); resumeSoon();
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    pause(); animateScrollBy(step(), 450); resumeSoon();
  });

  /* Glissé souris (une souris classique n'a pas de molette horizontale). */
  var isDown = false, didDrag = false, startX = 0, startScroll = 0;
  var DRAG_THRESHOLD = 6;

  row.addEventListener('mousedown', function (e) {
    isDown = true; didDrag = false;
    startX = e.pageX; startScroll = row.scrollLeft;
    pause();
  });
  window.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    var delta = e.pageX - startX;
    if (!didDrag && Math.abs(delta) > DRAG_THRESHOLD) {
      didDrag = true;
      /* Glissé confirmé : on neutralise le clic pour ne pas ouvrir un lien
         par accident au relâchement. */
      row.classList.add('is-drag-active');
    }
    if (didDrag) { row.scrollLeft = startScroll - delta; wrap(); }
  });
  window.addEventListener('mouseup', function () {
    if (!isDown) return;
    isDown = false;
    row.classList.remove('is-drag-active');
    resumeSoon();
  });

  /* Tactile : le scroll natif fait le travail, on met juste en pause. */
  row.addEventListener('touchstart',  function () { pause(); },     { passive: true });
  row.addEventListener('touchend',    function () { resumeSoon(); }, { passive: true });
  row.addEventListener('touchcancel', function () { resumeSoon(); }, { passive: true });

  /* Rotation / redimensionnement : le nombre de copies dépend de la largeur. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layout, 250);
  });
})();
